import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, TextField, Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ConfirmationModal from "views/components/ConfirmationModal";
import { parseDate } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";
import NoticeModal from "views/components/NoticeModal";

const HolidayMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { authToken } = useSelector((state) => state.login.authData);
  
  const [groupDetails, setGroupDetails] = useState([]); // Stores holiday data
  const [selectedDate, setSelectedDate] = useState(null); // Holds the selected date for adding a description
  const [newDescription, setNewDescription] = useState(""); // Holds the new description for a date
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const currentYear = new Date().getFullYear();
  const [disableButton, setDisableButton] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  // Create an array for the months of the current year
  const months = Array.from({ length: 12 }, (_, i) => new Date(currentYear, i, 1));
  
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  useEffect(() => {
    GetData();
  }, []);
  
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.HOLIDAY_MASTER_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    
    if (result?.data) {
      setGroupDetails(result?.data);
    }
  };

  // Function to save a new holiday description
  const saveHolidayDescription = () => {
    if (selectedDate && newDescription.trim()) {
      const parsedDate = parseDate(selectedDate);
      const updatedGroupDetails = groupDetails.map((holiday) => {
        if (holiday.date === parsedDate) {
          return { ...holiday, description: newDescription.trim() };
        }
        return holiday;
      });
      const isDateUpdated = updatedGroupDetails.some(
        (holiday) => holiday.date === parsedDate && holiday.description === newDescription.trim()
      );
  
      if (!isDateUpdated) {
        updatedGroupDetails.push({ date: parsedDate, description: newDescription.trim() });
      }
  
      setGroupDetails(updatedGroupDetails);
      setNewDescription("");
      setSelectedDate(null);
      setNoticeModal(false);
      setNoticeModalHeaderMsg("");
    }
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const dateFormat = parseDate(date);
    const descriptionPresent = groupDetails?.filter((item) => item?.date === parseDate(date))
    if(descriptionPresent?.length > 0){
      setConfirmationModal1(true);
      setConfirmationModalHeader1("Holiday Master");
      setConfirmationModalMsg1(`Do you want to update/delete holiday description on ${parseDateMDY(dateFormat)}`);
    }else{
      setConfirmationModal(true);
      setConfirmationModalHeader("Holiday Master");
      setConfirmationModalMsg(`Do you want to add holiday Description on ${parseDateMDY(dateFormat)}`);
    }
  };

  // Function to handle input change for the new description
  const handleDescriptionChange = (event) => {
    setNewDescription(event);
  };
  const isValidated = () => {
    let isValid = true;
  
    for (const item of groupDetails) {
      if (
        item.date === "" ||
        item.description === ""
      ) {
        isValid = false;
        break;
      }
    }
  
    return isValid;
  };
  const saveStandardDeduction = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.HOLIDAY_MASTER_CREATE,
        method: "POST",
        authToken: authToken,
        data: groupDetails,
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        toastUpdate("Success", "Holiday Master updated Successfully!", true);
        setRedirectURL(`/coreservice/Holiday`);
      }
    } else {
      toastUpdate("Error", "Please provide valid fields in all rows" , true);
    }
  };

  const handlecancelDeduction = () => {
    navigate("/coreservice/Holiday");
  };

  const handleNegativeResponse = () => {
      setConfirmationModal(false);
      setConfirmationModalHeader("");
      setConfirmationModalMsg("");
    };
  
    const handlePositiveResponse = async () => {
      handleNegativeResponse();
      setNoticeModalHeaderMsg("Description");
      setNoticeModal(true);
    };
    const handleNegativeResponse1 = (type) => {
      if (selectedDate && !type) {
        const parsedDate = parseDate(selectedDate);
        const updatedGroupDetails = groupDetails.filter(
          (holiday) => holiday.date !== parsedDate
        );
        setGroupDetails(updatedGroupDetails);
      }
      setConfirmationModal1(false);
      setConfirmationModalHeader1("");
      setConfirmationModalMsg1("");
    };
    const handlePositiveResponse1 = async () => {
      handleNegativeResponse1("noCall");
      setNoticeModalHeaderMsg("Description");
      setNoticeModal(true);
    };
  return (
    <Grid container>
      <Grid item xs={12}>
      <SubHeader
          label={
            params.deductionId
              ? "Edit Holiday"
              : "Create Holiday"
          }
          button1=" Save"
          button2=" Cancel"
          disabled1={disableButton}
          button1click={saveStandardDeduction}
          button2click={handlecancelDeduction}
        />
      </Grid>
      <Grid item xs={12}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', paddingLeft:'20px', gridGap:'40px'}}>
          {months.map((month, index) => (
            <div key={index} className={classes.container}>
              <h3 className={classes.calendarHeader}>
              <span
                style={{
                  display: 'inline-block',
                  fontWeight:'bold'
                }}
              >
                {month.toLocaleString('default', { month: 'long', year: 'numeric' })}
              </span>
              </h3>
              <Calendar
                value={month}
                view="month"
                showNavigation={false}
                onClickDay={handleDateClick}
                tileContent={({ date, view }) => {
                  if (view === 'month') {
                    const holiday = groupDetails.find(
                      (holiday) => new Date(holiday.date).toDateString() === date.toDateString()
                    );
                    return holiday ? (
                      <div
                        style={{
                          backgroundColor: '#516DF4',
                          borderRadius: '5px',
                          padding: '2px',
                          textAlign: 'center',
                          fontSize: '10px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          color: '#ffffff',
                        }}
                        title={holiday.description}
                      >
                        {holiday?.description}
                      </div>
                    ) : null;
                  }
                  return null;
                }}
                tileClassName={({ date, view }) => {
                  if (view === 'month') {
                    const holiday = groupDetails.find(
                      (holiday) => new Date(holiday.date).toDateString() === date.toDateString()
                    );
                    return holiday ? classes.holidayDate : null;
                  }
                  return null;
                }}
              />
            </div>
          ))}
        </div>
      </Grid>
       {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {confirmationModal && 
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
          positiveButtonText={'Yes'}
          negativeButtonText={"No"}
        />
      }
      {confirmationModal1 && 
        <ConfirmationModal
          confirmationModal={confirmationModal1}
          confirmationModalHeader={confirmationModalHeader1}
          confirmationModalMsg={confirmationModalMsg1}
          handleNegativeButton={handleNegativeResponse1}
          handlePositiveButton={handlePositiveResponse1}
          positiveButtonText={'Update'}
          negativeButtonText={"Delete"}
        />
      }
      {noticeModal && <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        closeModal={saveHolidayDescription}
        value={newDescription}
        onChange={handleDescriptionChange}
        label="Holiday Description"
        id="holiday_description"
        textField
      />}
    </Grid>
  );
};

export default HolidayMasterCreate;
